/**
 * API base URLs. Prefer same-origin `/api/...` when the UI is served from the app domain.
 * Override with REACT_APP_USERMGMT_BASE for local dev pointing at a remote API.
 */
export function getUserMgmtBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api/usermgmt`;
  }
  return "https://adaptexam.com/api/usermgmt";
}

export function getAssessmentMgmtBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api/assessmentmgmt`;
  }
  return "https://adaptexam.com/api/assessmentmgmt";
}

export function getAiMgmtBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api/aimgmt`;
  }
  return "https://adaptexam.com/api/aimgmt";
}

export function getQuestionMgmtBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api/questionmgmt`;
  }
  return "https://adaptexam.com/api/questionmgmt";
}

export function getInternalMgmtBase() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api/internalmgmt`;
  }
  return "https://adaptexam.com/api/internalmgmt";
}
